import { LineaVenta } from "../models/LineaVentaModel";
import { UserPayload } from "../models/SiteModel";

const URLAPI = process.env.REACT_APP_BASE_URL;

export async function fetchGuardarPresupuesto(user: UserPayload,
    idCliente: number, idLocal: number, lineaventa:LineaVenta[], plazo:number
) {
    const token = user.token;
    const payload = lineaventa.map((linea) => ({
      IdProducto: linea.producto.IDPRODUCTO, // Map from producto.id
      Codigo: linea.producto.CODIGO,
      Producto: linea.producto.PRODUCTO, // Map from producto.producto
      Cantidad: linea.cantidad, // Map from cantidad
      Precio: linea.producto.CONTADO, // Map from producto.contado
  }));
    const postData = JSON.stringify({
      Request:{
        Fecha: new Date().toISOString(),
        IdLocal: idLocal,
        IdCliente: idCliente,
        Cliente: "",
        IdEmpleado: 0,
        Total: payload.reduce((total, linea) => total + (linea.Cantidad * linea.Precio), 0),
        FormaPago: "Contado",
        Descuento: 0,
        Recargo: 0,
        Usuario: user.username,
        Seña: 0,
        IdCaja: 0,
        IdLista: 0,
        Plazo: plazo
      },
      Lineas: payload
    });
    const response = await fetch(
      `${URLAPI}/Presupuesto/GuardarPresupuesto`,
      {
        method: "POST", headers: {
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + token
        },
        body: postData
      }
    );
  
    const data = await response.json();
    return data;
  }
